import * as React from 'react';

import { IEditableServerSettings } from '../../../../ts/ServerApi/types/IEditableServerSettings';
import { IServerTimestamps } from '../../../services/ServerSettings';
import { SectionContainerBaseProps, SettingsFormikContainer } from '../GeneralSettingsPageBase';

export interface BaseReactSettingsCtrlProps {
  setCancelCallback: (cancelFn: () => void) => void;
  setSaveCallback: (saveFn: () => Promise<any> | void) => void;
  setOpenNavigationDialogCallback: (callback: Function) => void;  // Popup that appears there's unsaved changes and a user tries to navigate away
  setIsFormDirty: (isFormModified: boolean) => void;
  setIsFormValid: (isValid: boolean) => void;
  setIsBusyCallback: (isBusyFn: () => boolean) => void;  // Angular expects a function callback here
  mergeIntoParentScope?: (values: unknown) => void;
}

/**
 * A partial list of server settings.
 * This is meant for individual section components to pick a subset of the overall settings they use
 */
export type ServerSettingsProps<T extends keyof IEditableServerSettings = keyof IEditableServerSettings> = {
  settings: Pick<IEditableServerSettings, T>;
  serverTimestamps?: IServerTimestamps;
};

export type OuterServerSettingsProps = BaseReactSettingsCtrlProps & SectionContainerBaseProps
  & ServerSettingsProps;

export function ReactServerSettings(props: OuterServerSettingsProps){
  return <SettingsFormikContainer {...props} />;
}
